module.exports = new __parcel__URL__("77331_h.f07d667c.jpg").toString();